<template>
  <div>
    <div class="custom-header">
      <span class="pull-left big-font">
        <img class="header-logo" src="@/assets/syspeople.png" />
      </span>
      <span class="pull-right">
        <info-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          v-b-modal.info-modal
        />
        <code-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          @click.native="generateServiceNowSnippet()"
        />
        <download-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          @click.native="saveToOutput(true)"
        />
        <upload-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          v-b-modal.file-upload-modal
        />
        <save-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          @click.native="save()"
        />
        <settings-icon
          :width="44"
          :height="44"
          :color="'#fff'"
          v-if="user"
          v-b-modal.settings-modal
        />
        <span v-if="user" class="log-out" @click="$msal.signOut()">
          Log out
        </span>
        <span v-if="!user" class="pull-right">
          <span class="log-out" @click="$msal.signIn()"> Log in </span>
        </span>
      </span>
    </div>
    <info-box v-if="!user" />
    <div
      v-if="!user"
      style="display: flex; justify-content: center; width: 100%"
    >
      <button @click="$msal.signIn()" class="microsoft-login-button">
        <div style="align-items: center; display: flex; height: 100%">
          <div style="display: flex; justify-content: center; min-width: 26px">
            <microsoft-login />
          </div>
          <div style="width: 10px"></div>
          <div style="text-align: left; width: 100%">Login with Microsoft</div>
        </div>
      </button>
    </div>
    <div v-if="user" class="quick-settings-container">
      <button
        class="quick-settings-item"
        v-if="!editTableFields"
        @click="editTableFields = !editTableFields"
      >
        Edit fields
      </button>
      <button
        class="quick-settings-item"
        v-if="editTableFields"
        @click="editTableFields = !editTableFields"
      >
        Stop edit fields
      </button>
      <div class="quick-settings-item">
        <input
          type="checkbox"
          v-model="showLabels"
          id="showLabels"
          name="showLabels"
        />
        <label for="showLabels">Show labels</label>
      </div>

      <screen-shot
        :width="44"
        :height="44"
        :color="'#fff'"
        class="quick-settings-item"
        @click.native="downloadImage"
      />
      <trash-icon
        :width="44"
        :height="44"
        :color="'#fff'"
        class="quick-settings-item"
        @click.native="reset"
      />
      <div class="pull-right">
        Nodes: {{ this.scene.nodes.length }} Links:
        {{ this.scene.links.length }}
      </div>
    </div>

    <div v-if="user" class="header-row">
      <div
        v-for="(item, index) in orderedTables"
        :key="index"
        :value="index"
        v-bind:style="{ backgroundColor: item.color }"
        class="col"
        draggable
        @dragstart="startDrag($event, item)"
      >
        <span class="table-name-header"> {{ item.name }}</span>
        <div v-if="editTableFields">
          <div v-for="(field, index) in item.fields" :key="`${field}-${index}`">
            <input
              type="text"
              class="h-10 rounded-lg outline-none m-1"
              placeholder="Enter new field name"
              v-model="field.name"
            />
            <!--          Add Svg Icon-->
            <svg
              @click="addField(field, item.fields)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                fill="green"
                d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
              />
            </svg>
            <!--          Remove Svg Icon-->
            <svg
              v-show="item.fields.length > 1"
              @click="removeField(index, item.fields)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                fill="#EC4899"
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div
      style="height: 85vh"
      @drop="onDrop($event, 1)"
      @dragover.prevent
      @dragenter.prevent
    >
      <simple-flowchart
        style="height: 100%"
        id="flowchart"
        v-if="user"
        :scene.sync="scene"
        :height="scene.height"
        :showLabels="showLabels"
      ></simple-flowchart>
    </div>
    <code-modal :code="this.code" />
    <div>
      <b-modal
        :hide-footer="true"
        id="file-upload-modal"
        ref="file-upload-modal"
        title="Upload file"
        size="sm"
      >
        <file-reader @load="handleFileUpload($event)"></file-reader>
      </b-modal>
    </div>
    <info-modal />
    <settings-modal :scene="this.scene" />
  </div>
</template>
<script>
var _ = require("lodash");
import { msalMixin } from "vue-msal";
import * as htmlToImage from "html-to-image";

import SimpleFlowchart from "@/components/FlowChart/SimpleFlowchart";
import FileReader from "@/components/FileReader";
import InfoIcon from "@/components/Icons/InfoIcon";
import CodeIcon from "@/components/Icons/CodeIcon";
import SettingsIcon from "@/components/Icons/SettingsIcon";
import DownloadIcon from "@/components/Icons/DownloadIcon";
import UploadIcon from "@/components/Icons/UploadIcon";
import SaveIcon from "@/components/Icons/SaveIcon";
import TrashIcon from "@/components/Icons/TrashIcon";
import LogoutIcon from "@/components/Icons/LogoutIcon";
import ScreenShot from "@/components/Icons/ScreenShot";
import MicrosoftLogin from "@/components/Icons/MicrosoftLogin.vue";
import InfoBox from "@/components/InfoBox";
import InfoModal from "@/components/Modals/InfoModal";
import CodeModal from "@/components/Modals/CodeModal";
import SettingsModal from "@/components/Modals/SettingsModal";

const RELATIONSHIP_MAPPING_SOURCE = {
  cmdb_ci_service: "60bc4e22c0a8010e01f074cbe6bd73c3",
  service_offering: "60bc4e22c0a8010e01f074cbe6bd73c3",
  cmdb_ci_service_discovered: "60bc4e22c0a8010e01f074cbe6bd73c3",
  cmdb_ci_business_app: "60bc4e22c0a8010e01f074cbe6bd73c3",
  cmdb_ci: "60bc4e22c0a8010e01f074cbe6bd73c3",
};
const RELATIONSHIP_MAPPING_TARGET = {
  cmdb_ci_service: "runs_on",
  service_offering: "runs_on",
  cmdb_ci_service_discovered: "runs_on",
  cmdb_ci_business_app: "runs_on",
  cmdb_ci: "runs_on",
};

export default {
  components: {
    SimpleFlowchart,
    FileReader,
    InfoIcon,
    CodeIcon,
    SettingsIcon,
    DownloadIcon,
    UploadIcon,
    SaveIcon,
    LogoutIcon,
    ScreenShot,
    InfoBox,
    InfoModal,
    CodeModal,
    SettingsModal,
    TrashIcon,
    MicrosoftLogin,
    ScreenShot,
  },
  mixins: [msalMixin],

  data() {
    return {
      fileUploaded: false,
      scene: {
        height: 700,
        centerX: 1024,
        centerY: 140,
        scale: 1,
        nodes: [],
        links: [],
        rels: [
          {
            from: "Business Capability",
            to: "Business Application",
            relationship: {
              name: "Provided By :: Provides",
              sys_id: "4afd799338a02000c18673032c71b817",
            },
            sourceTable: "cmdb_ci_business_capability",
            targetTable: "cmdb_ci_business_app",
          },
          {
            from: "Business Capability",
            to: "Business Service",
            relationship: {
              name: "Provided By :: Provides",
              sys_id: "4afd799338a02000c18673032c71b817",
            },
            sourceTable: "cmdb_ci_business_capability",
            targetTable: "cmdb_ci_service",
          },
          {
            from: "Business Application",
            to: "Information Object",
            relationship: {
              name: "Uses :: Used by",
              sys_id: "cb5592603751200032ff8c00dfbe5d17",
            },
            sourceTable: "cmdb_ci_business_app",
            targetTable: "cmdb_ci_information_object",
          },
          {
            from: "Business Application",
            to: "Application Service",
            relationship: {
              name: "Consumes :: Consumed by",
              sys_id: "41008aa6ef32010098d5925495c0fb94",
            },
            sourceTable: "cmdb_ci_business_app",
            targetTable: "cmdb_ci_service_discovered",
          },
          {
            from: "Application Service",
            to: "Application",
            relationship: {
              name: "Dependes on :: Used by",
              sys_id: "1a9cb166f1571100a92eb60da2bce5c5",
            },
            sourceTable: "cmdb_ci_service_discovered",
            targetTable: "cmdb_ci_appl",
          },
          {
            from: "Application",
            to: "Infrastructure CIs",
            relationship: {
              name: "Runs on :: Runs",
              sys_id: "60bc4e22c0a8010e01f074cbe6bd73c3",
            },
            sourceTable: "cmdb_ci_appl",
            targetTable: "cmdb_ci",
          },
          {
            from: "Technical Service Offering",
            to: "Application Service",
            relationship: {
              name: "Contains :: Contained by",
              sys_id: "55c95bf6c0a8010e0118ec7056ebc54d",
            },
            sourceTable: "service_offering",
            targetTable: "cmdb_ci_service_discovered",
          },
          {
            from: "Technical Service Offering",
            to: "Infrastructure CIs",
            relationship: {
              name: "Contains :: Contained by",
              sys_id: "55c95bf6c0a8010e0118ec7056ebc54d",
            },
            sourceTable: "service_offering",
            targetTable: "cmdb_ci",
          },
          {
            from: "Business Service Offering",
            to: "Infrastructure CIs",
            relationship: {
              name: "Dependes on :: Used by",
              sys_id: "1a9cb166f1571100a92eb60da2bce5c5",
            },
            sourceTable: "service_offering",
            targetTable: "cmdb_ci",
          },
        ],
        tables: [
          {
            name: "Technical Service",
            value: "TS",
            table: "cmdb_ci_service",
            service_classification: "Technical Service",
            edit: false,
            export: true,
            color: "#e38e2d",
            id: 0,
            order: 0,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "Technical Service Offering",
            value: "TSO",
            table: "service_offering",
            service_classification: "Technical Service",
            edit: false,
            export: true,
            color: "#e38e2d",
            id: 1,
            order: 10,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "Application Service",
            value: "AS",
            table: "cmdb_ci_service_discovered",
            edit: false,
            export: true,
            color: "#e38e2d",
            id: 2,
            order: 20,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "CI",
            value: "CI",
            table: "cmdb_ci",
            edit: false,
            export: true,
            id: 3,
            color: "#444444",
            order: 30,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "Business Service",
            value: "BS",
            table: "cmdb_ci_service",
            service_classification: "Business Service",
            edit: false,
            export: true,
            color: "#9bb955",
            id: 4,
            order: 40,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "Business Service Offering",
            value: "BSO",
            table: "service_offering",
            service_classification: "Business Service",
            edit: false,
            export: true,
            color: "#9bb955",
            id: 5,
            order: 50,
            fields: [{ name: "Label", type: "String" }],
          },
          {
            name: "Business Application",
            value: "BA",
            table: "cmdb_ci_business_app",
            edit: false,
            export: true,
            color: "#68a1af",
            id: 6,
            order: 60,
            fields: [{ name: "Label", type: "String" }],
          },
        ],
      },
      file: "",
      newNodeType: 0,
      newNodeLabel: "",
      output: {
        objects: [],
        relationships: [],
      },
      showSettings: false,
      code: "",
      editTableFields: false,
      showLabels: false,
    };
  },
  computed: {
    orderedTables: function () {
      return _.orderBy(this.scene.tables, "order");
    },
    user() {
      let user = null;
      if (this.msal.isAuthenticated) {
        // Note that the dollar sign ($) is missing from this.msal
        user = {
          ...this.msal.user,
          profile: {},
        };
        if (this.msal.graph && this.msal.graph.profile) {
          user.profile = this.msal.graph.profile;
        }
      }
      return user;
    },
  },
  mounted() {
    if (localStorage.getItem("drawing")) {
      this.scene = JSON.parse(localStorage.getItem("drawing"));
    }
    // this.getAllContacts();
    // console.log(this.$msal.data);
    // this.$msal.acquireToken().then( response => console.log(response))
  },

  methods: {
    // async getAllContacts() {
    //   try {
    //     const response = this.$msal.msGraph("/me");
    //     console.log("Resp" + response);
    //   } catch (ex) {
    //     console.log(ex);
    //   }
    // },
    canvasClick(e) {
      console.log("canvas Click, event:", e);
    },
    addNode(nodeType, xCoor, yCoor) {
      let maxID = Math.max(
        0,
        ...this.scene.nodes.map((link) => {
          return link.id;
        })
      );
      //To get the correct node coordinates we calculate the center an subtract the magic '150' px from the yCoordinates
      this.scene.nodes.push({
        id: maxID + 1,
        x: xCoor - this.scene.centerX,
        y: yCoor - this.scene.centerY - 150,
        type: this.scene.tables[nodeType].value,
        table: this.scene.tables[nodeType].table,
        fields: _.cloneDeep(this.scene.tables[nodeType].fields),
        color: this.scene.tables[nodeType].color,
        label: "",
        edit: false,
      });
    },
    nodeClick(id) {
      console.log("node click", id);
    },
    nodeDelete(id) {
      console.log("node delete", id);
    },
    linkBreak(id) {
      console.log("link break", id);
    },
    linkAdded(link) {
      console.log("new link added:", link);
    },
    editTable: function (table) {
      this.editedTable = table;
    },
    async getData() {
      let res = await msal.msGraph("/me");
      return res;
    },
    generateServiceNowSnippet: function () {
      this.saveToOutput(false);

      var objs = "var objs = " + JSON.stringify(this.output.objects) + ";";
      var rels =
        "var rels = " + JSON.stringify(this.output.relationships) + ";";
      var space = `
  
  `;
      var data = objs;
      data += rels;
      data += space;

      data += `
    var sys_ids = [];
    var grParentBs = new GlideRecord("cmdb_ci_service");
    grParentBs.initialize();
    grParentBs.name = "TEMP PARENT";
    var parSysId = grParentBs.insert();


    for (var o in objs) {
        var obj = objs[o];

        try {
            var grInit = new GlideRecord(obj.table);
            grInit.addQuery("name", obj.label);
            grInit.query();
            if (grInit.next()) {
                gs.info("{0} already exists: ", [obj.label])
                objs[o].sys_id = grInit.sys_id;
                sys_ids.push(grInit.sys_id);
            } else {
                var gr = new GlideRecord(obj.table);
                gr.initialize();
                gr.name = obj.label;
                if (obj.type == "TS") {
                    gr.service_classification = "Technical Service";
                }
                if (obj.type == "BS") {
                    gr.service_classification = "Business Service";
                }
                if (obj.type == "TSO") {
                    gr.parent = parSysId;
                }
                if (obj.type == "BSO") {
                    gr.parent = parSysId;
                }

                for (field in obj.fields) {
                    var field = obj.fields[field];
                    gr[field.name.toLowerCase()] = field.value;
                }

                var sys_id = gr.insert();

                objs[o].sys_id = sys_id;
                sys_ids.push(sys_id);
                gs.info("Inserting {0} into table: {1} - sys_id", [obj.label, obj.table, sys_id])
            }
        }
        catch (ex) {
            gs.info(ex)
        }
    }
    gs.info(sys_ids);

    for (var r in rels) {
        var parentSysId = "";
        var childSysId = "";
        var relObj = rels[r];

        var parentGr = new GlideRecord(relObj.sourceTable);
        if(relObj.sourceTable == "service_offering"){
            parentGr.addQuery('name', relObj.source);
        }else{
            parentGr.addQuery('name', relObj.source);
        }
        parentGr.query();
        if (parentGr.next()) {
            parentSysId = parentGr.sys_id;
        }
        var childGr = new GlideRecord(relObj.targetTable);
        if(relObj.targetTable == "service_offering"){
            childGr.addQuery('name', relObj.target);
        }else{
            childGr.addQuery('name', relObj.target);
        }
        childGr.query();
        if (childGr.next()) {
            childSysId = childGr.sys_id;
        }
        try {
            var gr = new GlideRecord("cmdb_rel_ci");
            gr.initialize();
            gr.parent = parentSysId;
            gr.child = childSysId;
            gr.type = relObj.sourceRelType;
            var sys_id = gr.insert();
            rels[r].sys_id = sys_id;
        }
        catch (ex) {
            gs.info(ex)
        }
    }`;

      this.code = data;
      this.$bvModal.show("code-modal");
    },
    saveFile: function (fileName, array) {
      const data = JSON.stringify(array);
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = fileName + ".json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
    saveToOutput(saveAsFile) {
      this.output.objects = this.scene.nodes;

      for (var rel in this.scene.links) {
        var relationship = this.scene.links[rel];

        var sourceObject = this.scene.nodes.filter(
          (obj) => obj.id == relationship.from
        );
        var targetObject = this.scene.nodes.filter(
          (obj) => obj.id == relationship.to
        );

        // Get values from array
        sourceObject = sourceObject[0];
        targetObject = targetObject[0];

        var targetRel = "";
        // Check if relationship is found in the relationship array
        try {
          var targetRelArr = this.scene.rels.filter(function (object) {
            return (
              object.sourceTable == sourceObject.table &&
              object.targetTable == targetObject.table
            );
          });
          var targetRel = targetRelArr[0].relationship.sys_id;
        } catch (error) {
          var targetRel = "cb5592603751200032ff8c00dfbe5d17";
        }

        var relObject = {
          source: sourceObject.label,
          target: targetObject.label,
          sourceTable: sourceObject.table,
          targetTable: targetObject.table,
          sourceRelType: targetRel,
          targetRelType: targetRel,
        };
        this.output.relationships.push(relObject);
      }
      if (saveAsFile) {
        this.saveFile("my-drawing", this.scene);
      }
    },
    // downloadImage() {
    //   htmlToImage
    //     .toPng(document.getElementById("flowchart"))
    //     .then((dataUrl) => {
    //       var a = document.createElement("a");
    //       a.href = dataUrl;
    //       a.setAttribute("download", "mjello.png");
    //       a.click();
    //     });
    // },
    downloadImage() {
      htmlToImage
        .toSvg(document.getElementById("flowchart"))
        .then((dataUrl) => {
          var a = document.createElement("a");
          a.href = dataUrl;
          a.setAttribute("download", "mjello.svg");
          a.click();
        });
    },
    save() {
      localStorage.setItem("drawing", JSON.stringify(this.scene));
      this.$bvToast.toast("Saved drawing", {
        title: "Saved",
        toaster: "b-toaster-top-left",
        variant: "info",
        solid: true,
      });
    },
    reset() {
      localStorage.clear();
      this.scene = {
        height: 700,
        centerX: 1024,
        centerY: 140,
        scale: 1,
        nodes: [],
        links: [],
        tables: this.scene.tables,
        rels: this.scene.rels,
      };
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
    },
    startDrag: (evt, item) => {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", item.id);
    },
    onDrop(evt, list) {
      var clientX = evt.clientX;
      var clientY = evt.clientY;
      const itemID = evt.dataTransfer.getData("itemID");
      this.addNode(itemID, clientX, clientY);
    },
    handleFileUpload(file) {
      var sceneObj = JSON.parse(file);

      //Handle older versions of the files.
      sceneObj.tables.forEach((element) => {
        if (!element.hasOwnProperty("fields")) {
          element.fields = [{ name: "Label", type: "String" }];
        }
      });
      sceneObj.nodes.forEach((element) => {
        if (!element.hasOwnProperty("fields")) {
          element.fields = [
            { name: "Label", type: "String", value: element.label },
          ];
        }
      });

      this.scene = sceneObj;

      this.save();
      this.$refs["file-upload-modal"].hide();
      this.fileUploaded = true;
    },
    zoomIn() {
      this.scene.scale += 0.2;
    },
    zoomOut() {
      this.scene.scale -= 0.2;
    },
    addField(value, fieldType) {
      fieldType.push({ name: "", type: "String", value: "" });
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
  },
};
</script>
<style>
.custom-header {
  min-height: 60px;
  width: 100vw;
  align-items: center;
  display: flex;
  border-bottom: 1px solid #ccc !important;
  border-color: #000000 !important;
  background-color: #454746;
}

.header-logo {
  max-height: 60px;
}

.btn-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.header-row {
  display: flex;
  flex-wrap: wrap;
}

.col {
  flex: 1 0 5%; /* The important bit. This percentage decides your columns. 
The percent can be px. It just represents your minimum starting width.
*/
  display: flex;
  flex-direction: column;
  margin: 5px;
  min-height: 50px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.game-table {
  width: 100%;
  margin-bottom: 1rem;
  border-top: none !important;
}
.game-table th {
  border-bottom: 2px solid #000000;
  color: tomato;
}
.game-table td {
  color: #000000;
  padding: 0.75rem;
  vertical-align: top;
  border-top: none !important;
}
.card {
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  background-color: #e5e5e5;
  margin-top: 15px;
}

.card-4 .card-body {
  padding: 5px 5px 10px 10px;
  background-color: #09101d !important;
}

.table-container {
  max-width: 90rem;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

.pull-right {
  margin-right: 10px;
  margin-left: auto;
}
.pull-left {
  float: left;
  margin-left: 20px;
}

.big-font {
  font-size: 30px;
}

.btn {
  min-width: 200px;
  max-width: 900px;
  margin: 5px;
}
.code-textarea {
  width: 100%;
  min-height: 500px;
}

.plus-btn {
  position: absolute;
  bottom: 105px;
  left: 5px;
  border-radius: 4px;
  background-color: #a4c719;
}

.minus-btn {
  position: absolute;
  bottom: 55px;
  left: 5px;
  border-radius: 4px;
  background-color: #a4c719;
}
.reset-btn {
  position: fixed;
  bottom: 5px;
  left: 5px;
  border-radius: 4px;
  background-color: #a4c719;
}
.download-image-btn {
  position: fixed;
  bottom: 65px;
  left: 5px;
  border-radius: 4px;
  background-color: #a4c719;
}
.counter {
  position: fixed;
  bottom: 5px;
  right: 5px;
  border-radius: 4px;
  background-color: #a4c719;
}

.color-input {
  text-align: center;
  width: 5rem;
  padding: 0;
  border-width: 3px;
  border-radius: 0.375rem;
}

.log-out {
  border-color: #a4c719;
  color: #a4c719;
  border-style: solid;
  border-radius: 10px;
  border-width: 2px;
  padding: 5px;
}
.log-out:hover {
  background-color: #a4c719;
  color: #fff;
}

.row {
  width: auto;
}

.microsoft-login-button {
  display: block;
  border: 0px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 2px;
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-size: 19px;
  margin: 5px;
  min-width: 250px;
  overflow: hidden;
  padding: 0px 10px;
  user-select: none;
  height: 50px;
  background: rgb(50, 159, 253);
}

.table-name-header {
  font-weight: bold;
  text-shadow: rgb(255, 255, 255) 0.2px;
}

.quick-settings-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline; /*Align the baselines of the flex items*/
  align-items: center;
  /* justify-content: space-evenly; */
  padding: 10px;
  /* background-color: #4f5861; */
  color: #fff;
  background-color: #303030;
}

.quick-settings-item {
  margin-left: 5px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/Pages/Start.vue